const AdminFormFieldSeparator = () => {
	return <div style={{ height: "3px" }} />;
};

export default AdminFormFieldSeparator;
